/** Common markets for the onboarding form; any ISO country/currency is accepted by the API. */
export const COUNTRIES = [
  { value: 'IN', label: 'India' },
  { value: 'US', label: 'United States' },
  { value: 'GB', label: 'United Kingdom' },
  { value: 'AE', label: 'United Arab Emirates' },
  { value: 'SA', label: 'Saudi Arabia' },
  { value: 'SG', label: 'Singapore' },
  { value: 'AU', label: 'Australia' },
  { value: 'CA', label: 'Canada' },
  { value: 'DE', label: 'Germany' },
  { value: 'FR', label: 'France' },
  { value: 'NL', label: 'Netherlands' },
  { value: 'ID', label: 'Indonesia' },
  { value: 'MY', label: 'Malaysia' },
  { value: 'BD', label: 'Bangladesh' },
  { value: 'NP', label: 'Nepal' },
  { value: 'LK', label: 'Sri Lanka' },
  { value: 'BR', label: 'Brazil' },
  { value: 'MX', label: 'Mexico' },
  { value: 'ZA', label: 'South Africa' },
  { value: 'NG', label: 'Nigeria' },
];

const CURRENCY_BY_COUNTRY: Record<string, string> = {
  IN: 'INR',
  US: 'USD',
  GB: 'GBP',
  AE: 'AED',
  SA: 'SAR',
  SG: 'SGD',
  AU: 'AUD',
  CA: 'CAD',
  DE: 'EUR',
  FR: 'EUR',
  NL: 'EUR',
  ID: 'IDR',
  MY: 'MYR',
  BD: 'BDT',
  NP: 'NPR',
  LK: 'LKR',
  BR: 'BRL',
  MX: 'MXN',
  ZA: 'ZAR',
  NG: 'NGN',
};

export const CURRENCIES = [...new Set(Object.values(CURRENCY_BY_COUNTRY))]
  .sort()
  .map((c) => ({ value: c, label: c }));

export function defaultCurrencyFor(country: string): string {
  return CURRENCY_BY_COUNTRY[country] ?? 'USD';
}

export function guessCountry(): string {
  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
  if (tz === 'Asia/Kolkata' || tz === 'Asia/Calcutta') return 'IN';
  const region = navigator.language.split('-')[1]?.toUpperCase();
  return region && COUNTRIES.some((c) => c.value === region) ? region : 'US';
}
